// extracted by mini-css-extract-plugin
export default {"projectsSection":"ProjectsSection_projectsSection__COTMl","header":"ProjectsSection_header__miE3y"};